<template>
  <div class="table-edit-input">
    <el-popover placement="top" width="220" trigger="manual" v-model="editShow">
      <el-link type="primary" slot="reference" @click="editShow = !editShow"
        >{{ info[propsName] | toDate }} <i class="el-icon-edit"></i
      ></el-link>
      <div class="change-box">
        <el-date-picker
          v-model="info[propsName]"
          type="date"
          size="mini"
          placeholder="选择日期"
          :picker-options="{ firstDayOfWeek: 1 }"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="editShow = false">取消</el-button>
        <el-button type="primary" :loading="loading" size="mini" @click="sub">确定</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editShow: false,
      loading: false,
    }
  },
  props: {
    info: Object,
    propsName: String,
    url: String,
  },
  filters: {
    toDate(date) {
      return date ? date.substring(0, 10) : ''
    },
  },
  methods: {
    sub() {
      this.loading = true
      this.$util
        .put(this.url + '/' + this.info.id, {
          field: this.propsName,
          value: this.info[this.propsName],
        })
        .then(() => {
          this.editShow = false
          this.$emit('subQuick')
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style scoped>
.change-box {
  margin-bottom: 10px;
}
</style>
